import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  const cats = ["All", ...new Set(posts.map((p) => p.category))];
  const filtered = cat === "All" ? posts : posts.filter((p) => p.category === cat);

  return (
    <div data-testid="blog-page">
      <section className="section-pad container-luxe">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <p className="overline">The WOWSHE Journal</p>
            <h1 className="font-display text-5xl md:text-6xl text-aubergine mt-6 leading-tight">
              Essays for women <em className="text-rose not-italic">who read deeply.</em>
            </h1>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap gap-2">
          {cats.map((c) => (
            <button key={c} data-testid={`blog-cat-${c.replace(/\s/g,'-').toLowerCase()}`} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-xs uppercase tracking-widest border ${cat===c ? "bg-aubergine text-ivory border-aubergine" : "border-aubergine/20 text-plum"}`}>
              {c}
            </button>
          ))}
        </div>

        {filtered[0] && (
          <Link to={`/blog/${filtered[0].id}`} className="mt-12 block">
            <article className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <img src={filtered[0].image} alt="" className="rounded-2xl h-[480px] w-full object-cover" />
              <div>
                <p className="overline">{filtered[0].category}</p>
                <h2 className="font-display text-4xl md:text-5xl text-aubergine mt-4 leading-tight">{filtered[0].title}</h2>
                <p className="mt-5 text-plumSoft font-light text-lg leading-relaxed">{filtered[0].excerpt}</p>
                <p className="mt-6 text-sm text-plum">By {filtered[0].author}</p>
                <span className="mt-6 inline-flex items-center gap-2 text-plum text-sm">Read essay <ArrowUpRight className="w-4 h-4" /></span>
              </div>
            </article>
          </Link>
        )}

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.slice(1).map((p) => (
            <Link key={p.id} to={`/blog/${p.id}`} data-testid={`blog-card-${p.id}`} className="card-luxe overflow-hidden group flex flex-col">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <span className="overline">{p.category}</span>
                <h3 className="font-display text-xl text-aubergine mt-2 leading-snug">{p.title}</h3>
                <p className="text-sm text-plumSoft mt-3 font-light line-clamp-2">{p.excerpt}</p>
                <p className="mt-4 text-xs text-plum">By {p.author}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
